export default __webpack_public_path__ + "static/media/searchHelperValues.e6cedb68.png";